// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.investment-estimate-software[data-v-85ed1574] {
  padding: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/views/wait.vue","webpack://./wait.vue"],"names":[],"mappings":"AACA;EACE,aAAA;ACAF","sourcesContent":["\n.investment-estimate-software {\n  padding: 20px;\n}\n",".investment-estimate-software {\n  padding: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
